import Button from '@/components/Button'
import Title from '@/components/Title'
import { useCurrentUser, usePage } from '@/hooks'
import {
  urbanIcon1,
  urbanIcon2,
  urbanIcon3,
  urbanLogo,
  userIcon,
  zhekaUrbanModal
} from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from './styles/urban_benefits.module.scss'

const UrbanClubBenefits = (): React.ReactElement => {
  const currentUser = useCurrentUser()
  const page = usePage()

  const { config } = page?.init_state?.global

  return (
    <div className={style.urban_content}>
      <div className={style.urban_left}>
        <GxIcon src={urbanLogo} className={style.urban__logo} />
        <Title type='h2' className={style.urban__title}>
          Преимущества участия в Клубе
        </Title>

        <ul className={style.benefits_list}>
          <li className={style.benefits__item}>
            <div className={style.benefits__icon_wrap}>
              <GxIcon src={urbanIcon1} className={style.benefits__icon} />
            </div>
            <Title type='h3' theme='h4' className={style.benefits__title}>
              Получай знания
            </Title>
            <p className={style.benefits__text}>
              Посещай уникальные мастер-классы, онлайн-лекции, семинары и
              круглые столы. Приходи на открытые образовательные мероприятия.
              Обсуждай актуальные задачи отрасли с профессионалами. Встречайся с
              интересными людьми.
            </p>
          </li>
          <li className={style.benefits__item}>
            <div className={style.benefits__icon_wrap}>
              <GxIcon src={urbanIcon2} className={style.benefits__icon} />
            </div>
            <Title type='h3' theme='h4' className={style.benefits__title}>
              Тренируй навыки
            </Title>
            <p className={style.benefits__text}>
              Приобретай новые способности и доводите их до совершенства под
              руководством опытных специалистов отрасли. Выполняй задания
              наставника - раскрой свой потенциал.
            </p>
          </li>
          <li className={style.benefits__item}>
            <div className={style.benefits__icon_wrap}>
              <GxIcon src={urbanIcon3} className={style.benefits__icon} />
            </div>
            <Title type='h3' theme='h4' className={style.benefits__title}>
              Развивай умения
            </Title>
            <p className={style.benefits__text}>
              Выбирай интересные кейсы, решайте задачи, пройди практику и
              стажировки в Фонде! Сделай осознанный выбор будущей профессии!
            </p>
          </li>
        </ul>

        {currentUser.isLogin
          ? (
            <Button
              size='large'
              wide
              highlight
              href={config.urban_club}
              className={style.urban__button}
            >
              Перейти к клубу
            </Button>
            )
          : (
            <Button
              size='large'
              wide
              highlight
              href={config.authorization}
              className={style.urban__button}
            >
              <GxIcon src={userIcon} slot='icon-left' />
              Вход/Регистрация
            </Button>
            )}
      </div>
      <img
        src={zhekaUrbanModal}
        width='270px'
        height='561px'
        alt=''
        className={style.urban__image}
      />
    </div>
  )
}

export default UrbanClubBenefits
